export class CampaignTags extends HTMLElement {
  constructor(domain_id, existing_tags=[]) {
    super();
    this.domain_id = domain_id;
    this.selected_tags = existing_tags;
    this.deleted_rows = [];
  }

  async connectedCallback() {
    this.available_tags = new DataBinder(`/admin/domains/${this.domain_id}/tags`, true)
    await this.available_tags.fetchData();
    
    this.innerHTML = `<div class="row">
            <label>Tags</label>
            <br>
            <span>This can help organize and identify your campaigns.</span>
            <button class="btn btn-outline-primary ${this.selected_tags.length > 0 ? "hidden" : ""}" style="margin-left:40px">Add Tag</button>
            <div class="campaign_tags_container" style="margin: 20px 0px"></div>
          </div>`

    this.selected_tags.forEach((tag) => this.addRow(tag))

    this.querySelector('button').addEventListener('click', function(e) {
      e.preventDefault();
      e.target.classList.add("hidden");
      this.addRow();
    }.bind(this));
  }

  addRow(tag = null) {
    this.querySelector(".campaign_tags_container").appendChild(new CampaignTag(tag, this.addRow.bind(this), this.removeRow.bind(this), this.tagChange.bind(this), this.available_tags.data, this.selected_tags));
    this.tagChange();
  }

  removeRow(row, data) {
    row.remove();
    if(data != null) {
      data._destroy = true;
      this.deleted_rows.push(data);
    }

    if(this.querySelectorAll(".campaign_tags_container campaign-tag").length == 0) {
      this.querySelector("button").classList.remove("hidden");
    }
    this.tagChange();
  }

  tagChange() {
    this.selected_tags = [];
    this.querySelectorAll(".campaign_tags_container campaign-tag").forEach((tagElem) => {
      let tag = tagElem.getData();
      if(tag.tag_id != null) this.selected_tags.push(tag.tag_id)
    });

    this.querySelectorAll(".campaign_tags_container campaign-tag").forEach((tagElem) => tagElem.updateAvailableTags(this.selected_tags));
  }

  validate() {
    let isValid = true;
    this.querySelectorAll('select').forEach(sel => sel.classList.remove('error'))
    this.getData().forEach((tag) => { if(tag.tag_id == null) isValid = false } )
    this.querySelectorAll('select').forEach(sel => sel.value == 'null' ? sel.classList.add('error') : null)
    return isValid;
  }

  getData() {
    let data = [];
    this.querySelectorAll(".campaign_tags_container campaign-tag").forEach( (tagElem) => data.push(tagElem.getData()) );
    return data.concat(this.deleted_rows);
  }
}

customElements.define('campaign-tags', CampaignTags)


class CampaignTag extends HTMLElement {
  constructor(tag, addRow, removeRow, tagChange, available_tags, selected_tags) {
    super();
    this.tag = tag;
    this.addRow = addRow;
    this.removeRow = removeRow;
    this.tagChange = tagChange;
    this.available_tags = available_tags;
    this.selected_tags = selected_tags;
  }

  async connectedCallback() {
    this.innerHTML = `<div class="row">
      <div class="col-md-5 no-gutters">
        <label>Tag Name</label>
        <select type="text" class="form-control" value="">
          <option value="null">Select</div>
        </select>
      </div>
      <div class="col-md-5">
        <label>Value</label>
        <input type="text" class="form-control" placeholder="Optional" value="" maxlength="60">
      </div>
      <div class="col-md-2 dni-url-add" style="line-height:30px;">
        <a class="remove_row"><span class="fa fa-minus"></span></a>
        <a class="add_row"><span class="fa fa-plus"></span></a>
      </div>
    </div>`

    let options = this.available_tags.map((tag) => `<option value="${tag.tag_id}">${tag.auto_group_name} - ${tag.tag_group_name} - ${tag.tag_name}</option>`).join("")
    this.querySelector("select").innerHTML = `<option value="null">Select</div>${options}`;
    this.querySelector("select").addEventListener('change', this.tagChange)

    if(this.tag != null) {
      this.querySelector('select').value = this.tag.tag_id;
      this.querySelector('input').value = this.tag.tag_value;
    }

    this.querySelector(".fa-plus").addEventListener("click", () => this.addRow() )
    this.querySelector(".fa-minus").addEventListener("click", () => this.removeRow(this, this.tag))
  }

  getData() {
    let tag_id = this.querySelector('select').value;
    let tag_value = this.querySelector('input').value.trim();
    let tag = this.tag != null ? this.tag : {};
    tag.tag_id = tag_id != "null" ? Number(tag_id) : null,
    tag.tag_value = tag_value != "" ? tag_value : null
    return tag;
  }

  updateAvailableTags(selected_tags) {
    let currentValue = this.querySelector("select").value;
    let new_available_tags = this.available_tags.filter((tag) => tag.tag_id == currentValue || !selected_tags.includes(tag.tag_id))
    let options = new_available_tags.map((tag) => `<option value="${tag.tag_id}">${tag.auto_group_name} - ${tag.tag_group_name} - ${tag.tag_name}</option>`).join("")
    this.querySelector("select").innerHTML = `<option value="null">Select</div>${options}`;
    this.querySelector("select").value = currentValue;
  }
}

customElements.define('campaign-tag', CampaignTag)